import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import Carousel from 'srcReact/components/common2/Carousel'
import MixrCard from 'srcReact/components/common2/MixrCard'
import { discoverActions } from 'srcReact/DiscoverPage'
import NotFound from 'srcReact/components/common2/NotFound'
import Spinner from 'srcReact/components/common2/Spinner'
import { decode } from 'html-entities/lib/index'
import { checkNested } from 'srcReact/helpers/validator'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { canCreateGroup } from 'srcReact/helpers/userHelper'

const MyMixrs = ({ showAccordion, mixrScope, mixrOrderChanged }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const {
    common: { isMobile, isNative, userLocation },
    discover: { all },
    organization: { current_organization }
  } = useSelector((state) => state)
  useEffect(() => {
    if (mixrOrderChanged) {
      // nativeapp
      if (isNative) {
        dispatch(
          discoverActions.getDiscoverMixrList(
            urlSearchParams('id_workplace').toString(),
            mixrScope,
            urlSearchParams('lat'),
            urlSearchParams('lon'),
            pagination.nextOffset
          )
        )
        return
      }

      if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
        const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
        if (workplaceIds && workplaceIds.length >= 1 && userLocation) {
          dispatch(
            discoverActions.getDiscoverMixrList(
              workplaceIds.toString(),
              mixrScope,
              userLocation.latitude,
              userLocation.longitude,
              pagination.nextOffset
            )
          )
        }
      }
    }
  }, [mixrOrderChanged])
  useEffect(() => {
    // nativeapp
    if (isNative && pagination.isPagination) {
      dispatch(
        discoverActions.getDiscoverMixrListPagination(
          urlSearchParams('id_workplace').toString(),
          mixrScope,
          urlSearchParams('lat'),
          urlSearchParams('lon'),
          pagination.nextOffset
        )
      )
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1 && pagination.isPagination && userLocation) {
        dispatch(
          discoverActions.getDiscoverMixrListPagination(
            workplaceIds.toString(),
            mixrScope,
            userLocation.latitude,
            userLocation.longitude,
            pagination.nextOffset
          )
        )
      }
    }
  }, [pagination])

  const handleNextEnd = (currentItem, pageIndex) => {
    if (mixrScope === 'bestmatch' && all.stats.total_mixrs - all.mixr_list.length > 0) {
      setPagination({ nextOffset: all.mixr_list.length, isPagination: true })
    } else if (mixrScope === 'allmixrs' && all.stats.total_all_mixrs - all.mixr_list.length > 0) {
      setPagination({ nextOffset: all.mixr_list.length, isPagination: true })
    }
  }

  let mixrsDataList = [...all.mixr_list]
  if (current_organization && canCreateGroup(current_organization) && all.mixr_list && all.mixr_list.length >= 1) {
    mixrsDataList.splice(appConstantSettings.CTA_BUTTON_DISPLAY - 1, 0, {
      index: appConstantSettings.CTA_BUTTON_DISPLAY - 1,
      is_cta_button: true
    })
  }

  return (
    <div className={styles.mymirsWrapper}>
      {all.myMixrsLoading && !all.myMixrsLoaded ? (
        <Spinner customCss={styles.spinner} />
      ) : showAccordion && all.mixr_list && all.mixr_list.length >= 1 ? (
        <Carousel
          className={styles.carousel}
          itemPadding={isMobile ? [0, 0] : [10, 10]}
          onNextEnd={handleNextEnd}
          showArrows={isMobile ? false : true}
          {...(isMobile
            ? {
                breakPoints: [{ width: 1, itemsToShow: 2.2, itemsToScroll: 1 }]
              }
            : {})}
          isArrowEdge={false}>
          {mixrsDataList.map((m, i) => (
            <MixrCard
              key={i}
              mixrId={m.id}
              groupId={m.group_id}
              startDate={m.event_utc_start_datetime}
              endDate={m.event_utc_end_datetime}
              utcOffset={m.event_utc_offset}
              timezone={m.timezone}
              timezoneFullName={m.timezone_name}
              location={m.location}
              name={decode(m.group_name)}
              participants={m.number_of_participants}
              url={m.mixr_url}
              picture={m.mixr_picture && m.mixr_picture}
              // notifications={m.notifications}
              title={decode(m.mixr_title)}
              description={m.description}
              attendance={m.mixr_attending_type}
              userAttendance={m.mixr_attending_type}
              color={m.mixr_color ? m.mixr_color : appConstantSettings.DEFAULT_COLOR.name}
              isVisibility={m.visibility !== 'public'}
              isRecurrence={m.recurrence_type === 'recurring'}
              isViewModal={true}
              isCtaButton={m.is_cta_button}
              isSuspended={
                checkNested(all, 'moderation_info', 'mixrs', 'suspended_mixrs') &&
                all.moderation_info.mixrs.suspended_mixrs.some((x) => x === m.mixr_id)
              }
              groupType={m.group_type}
              origin='carousel'
            />
          ))}
        </Carousel>
      ) : (
        showAccordion &&
        all.mixr_list &&
        all.mixr_list.length === 0 &&
        all.myMixrsLoaded && <NotFound title={t('discover.mymixrs.notFound.title')} className={styles.notFound} />
      )}
    </div>
  )
}

export default MyMixrs
